var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelop = function SvgEnvelop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#C29B40",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.653 4.667H8.347a5.68 5.68 0 0 0-5.68 5.68v11.306a5.68 5.68 0 0 0 5.68 5.68h15.306a5.68 5.68 0 0 0 5.68-5.68V10.347a5.68 5.68 0 0 0-5.68-5.68",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 17.333a4.6 4.6 0 0 1-2.907-1.053L8.56 12.533A1.016 1.016 0 1 1 9.893 11l4.507 3.746a2.55 2.55 0 0 0 3.28 0l4.387-3.72a.986.986 0 0 1 1.333.107 1.014 1.014 0 0 1-.107 1.414l-4.386 3.72A4.52 4.52 0 0 1 16 17.333"
  })));
};
export default SvgEnvelop;